import React, { useRef, useEffect } from "react";
import { Loader } from "lucide-react";
import TextArea from "../TextArea/TextArea";
import iconSend from "../../assets/icons/iconSend.svg";
import styles from "./ChatInput.module.css";

const ChatInput = ({
  inputMessage,
  setInputMessage,
  isLoading,
  onSendMessage,
  theme,
}) => {
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      onSendMessage();
    }
  };

  const handleSend = () => {
    if (inputMessage.trim() && !isLoading) {
      onSendMessage();
    }
  };

  return (
    <div className={styles.inputArea}>
      <div className={styles.inputContainer}>
        <TextArea
          inputRef={inputRef}
          value={inputMessage}
          onChange={(e) => setInputMessage(e.target.value)}
          onKeyDown={handleKeyPress}
          placeholder="Введите сообщение"
          disabled={isLoading}
          onBlur={(e) => {
            e.target.style.borderColor = "#181818";
            e.target.style.boxShadow = "none";
          }}
          theme={{
            textColor: theme.textColor,
            backgroundColor: theme.backgroundColor,
            primaryColor: theme.primaryColor,
          }}
        />
        <button
          onClick={handleSend}
          disabled={!inputMessage.trim() || isLoading}
          className={styles.sendButton}
          title="Отправить сообщение"
        >
          {isLoading ? (
            <Loader size={20} className={styles.sendButtonSpinner} />
          ) : (
            <img src={iconSend} alt="" className={styles.sendButtonIcon} />
          )}
        </button>
      </div>
    </div>
  );
};

export default ChatInput;
